<template>
  <div class="d-lg-flex align-items-center">
    <div class="mr-lg-5">
      <web-chart
        :categories="categories"
        :series="multiSeries"
        :chartStyles="{chordStep: 10}"
      >
        <template v-slot:area>
          <div
            class="text-left"
            v-for="(line, index) in tooltipLines"
            :key="`tl${index}`"
          >
            <strong>{{line.label}}: </strong>{{ Math.ceil(line.value * 100) }}%
          </div>
        </template>
        <template v-slot:label="label">
          <span
            class="d-flex align-items-center"
            v-b-tooltip.hover :title="categories[label.index].name"
            @mouseenter="active = label.index"
            @mouseleave="active = -1"
          >
            <i
              class="lgf mr-2 fs-240"
              :class="categories[label.index].icon"
            />
            <span class="text-info font-weight-bold fs-120" style="pointer-events:none">
              {{ Math.ceil(series[label.index].value * 100) }}%
            </span>
          </span>
        </template>
      </web-chart>
    </div>
    <div class="w-lg-50">
      <div
        v-for="(category, index) in categories"
        :key="`p${index}`"
        class="mb-3 d-flex align-items-center"
      >
        <i
          class="lgf mr-3 fs-240"
          :class="{[category.icon]: true, 'text-info': active === index}"
          v-b-tooltip.hover :title="category.name"
        />
        <span class="small" :class="{'font-weight-bolder text-info': active === index}">{{ category.description }}</span>
      </div>
      <slot name="footer"/>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
  import WebChart from '../../common/charts/WebChart'

  export default {
    components: {
      WebChart
    },
    props: {
      categories: {
        type: Array,
        required: true,
        default: () => ([])
      },
      series: {
        type: Array,
        required: true,
        default: () => ([])
      },
    },
    data() {
      return {
        active: -1
      }
    },
    watch: {
      active(active) {
        console.log(active)
      }
    },
    computed: {
      tooltipLines() {
        var lines = []
        _.forEach(this.series, (dimension, index) => {
          lines.push({
            label: this.categories[index].name,
            value: dimension.value
          })
        })
        return lines
      },
      multiSeries() {
        return [this.series]
      }
    },
    methods: {
      labelFor(slug) {
        return labelFor(slug)
      },
    }
  }
</script>